import { Component, OnInit } from '@angular/core';
import { CustomizationManager } from '@core/services/customization-manager.service';
import { PolicyCreationService } from '@modules/dashboard/services/policy.service';
import { HubioLoginService } from '@hubio/hubio-login';
import { UserLoginService } from '@core/services/user-login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public username = '';

  constructor(
    private auth: HubioLoginService,
    private CustomizationManager: CustomizationManager,
    private policyService: PolicyCreationService,
    private userLoginService: UserLoginService
  ) { }

  ngOnInit() {
    const currentUser = this.auth.getCurrentUserTokenDecoded();
    if (currentUser) {
      this.username = currentUser.email ?? '';
    }
    this.userLoginService.recordLoginIfNeeded();
  }

  logout() {
    this.policyService.clearBrokers();
    this.userLoginService.clearTracking();
    this.auth.logout();
  }
}
